import { createSelector } from '@reduxjs/toolkit'
import { validateFlowData } from '../studio/algorithms_and_functions/validation/validation'
import IssueIntensity from '../studio/algorithms_and_functions/validation/IssueIntensity'

// Validation issues of all studio workflows, keyed by studio id.
// Memoized: only recalculated when state.studio changes.
export const selectStudioIssues = createSelector(
    state => state.studio,
    studio => Object.fromEntries((studio || []).map(workflow => [workflow.id, validateFlowData(workflow.flowData)]))
)

// Studio workflows that can be gifted to the market: start, end and at least
// two steps, and no validation errors.
export const selectGiftableStudioTasks = createSelector(
    state => state.studio,
    selectStudioIssues,
    (studio, issues) => (studio || []).filter(task =>
        task.flowData?.nodes?.length > 3 &&
        !issues[task.id]?.some(issue => issue.intensity === IssueIntensity.Error))
)
